import {
  NotificationConditionTypeEnum,
  getNotificationConditionTypeString,
  notificationByIdQuery,
} from '@/entities/notifications'
import { formatDateTimeStringToDateString } from '@/shared/lib/form-utils'
import { ErrorResult, HidingSpin } from '@/shared/ui'
import { Button, Descriptions, Image, Modal } from 'antd'
import { useUnit } from 'effector-react'

import {
  $isNotificationViewModalOpened,
  notificationViewModalClosed,
} from '../../model/notification-view-modal.model'

export const NotificationViewModal = () => {
  const queryStatus = useUnit(notificationByIdQuery.$status)

  const { data, pending, error } = useUnit(notificationByIdQuery)
  const open = useUnit($isNotificationViewModalOpened)
  const close = useUnit(notificationViewModalClosed)

  return (
    <Modal
      title="Просмотр уведомления"
      open={open}
      onCancel={() => {
        close()
      }}
      destroyOnHidden
      centered
      footer={null}
      width={600}
    >
      <HidingSpin
        spinning={queryStatus !== 'initial' && (pending || (!data && !error))}
      >
        {data && !error ? (
          <Descriptions
            column={1}
            bordered
            styles={{ label: { width: '30%' }, content: { width: '70%' } }}
          >
            <Descriptions.Item label="Название">
              {data.name || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Описание">
              {data.description || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Обложка">
              {data.picture?.fullCdnUrl ? (
                <Image
                  src={data.picture?.fullCdnUrl}
                  alt="Обложка уведомления"
                  width={100}
                  style={{ objectFit: 'cover' }}
                />
              ) : (
                '-'
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Условия отправки">
              {getNotificationConditionTypeString(data.conditionType) || '-'}
            </Descriptions.Item>
            {data.conditionType === NotificationConditionTypeEnum.AtTime &&
              data.sendOnDate && (
                <Descriptions.Item label="Дата и время отправки">
                  {formatDateTimeStringToDateString(data.sendOnDate, false)}
                </Descriptions.Item>
              )}
          </Descriptions>
        ) : (
          <ErrorResult
            error={error}
            notFoundConfig={{
              subTitle: error ? 'Уведомление не найдено' : 'Ошибка открытия',
              extra: <Button onClick={() => close()}>Закрыть</Button>,
            }}
          />
        )}
      </HidingSpin>
    </Modal>
  )
}
